module.exports = __webpack_public_path__ + "static/media/Skincare.78eacdd5.jpg";